import { ORDER_STATUS, ORDER_STATUS_WITH_TYPE_TEXT, ORDER_TYPE } from '@/utils/constants';

export default {
  currentDraftId({ draftOrder: { draftId: id } } = {}) {
    return id || null;
  },
  draftBuyingMethod({ draftOrder: { buyingType: type, status } = {} }) {
    const isValidType = Object.values(ORDER_TYPE).includes(type);
    if (!isValidType) {
      return '';
    }
    const isNormalType = type === ORDER_TYPE.NORMAL;
    if (!isNormalType) {
      const typeKeys = Object.keys(ORDER_TYPE);
      const matchItemKey = typeKeys.find((key) => ORDER_TYPE[key] === type);
      return matchItemKey !== -1 ? ORDER_STATUS_WITH_TYPE_TEXT[matchItemKey] : '';
    }

    const statusKeys = Object.keys(ORDER_STATUS);
    const matchItemKey = statusKeys.find((key) => ORDER_STATUS[key] === status);
    return matchItemKey !== -1 ? ORDER_STATUS_WITH_TYPE_TEXT[matchItemKey] : '';
  },
  draftMenuId({ draftOrder: { menuId: id } } = {}) {
    return id || null;
  },
  draftStoreId({ draftOrder: { storeId: id } } = {}) {
    return id || null;
  },
  selectedDepartmentIds({ draftOrder: { departmentIds: ids } } = {}) {
    return ids || [];
  },
  originSelectedMembers({ draftOrder: { selectedMembers } } = {}) {
    return selectedMembers || {};
  },
};
